/**
 * The home screen's hero: a small hand of the selected game's own cards, held
 * fanned under the lamp. Switching game re-deals it, which is motion answering
 * the player's tap rather than decoration, and it is the only motion on the
 * screen. Keyed by game so React mounts a fresh fan and the deal plays again.
 *
 * Purely pictorial: one accessible name for the whole fan, the faces hidden.
 */
import type { CSSProperties } from 'react'
import type { GameId } from '@cards/shared'
import { cardSrc } from '../cards/assets'
import { useSettings } from '../settings/settings'
import { introOf } from './gameIntro'

/** Degrees between neighbouring cards. */
const SPREAD = 9

export function HeroFan({ game }: { game: GameId }): JSX.Element {
  const [settings] = useSettings()
  const { fan, name } = introOf(game)
  const mid = (fan.length - 1) / 2
  return (
    <div className="hero-fan" key={game} role="img" aria-label={`A hand of ${name}`}>
      {fan.map((card, i) => {
        const turn = (i - mid) * SPREAD
        const style = {
          '--turn': `${turn}deg`,
          '--drop': `${Math.abs(i - mid) * Math.abs(i - mid) * 3}px`,
          '--i': i,
          zIndex: i + 1,
        } as CSSProperties
        return (
          <img key={card} className="hero-card" src={cardSrc(card, settings.deck)} alt="" draggable={false} style={style} />
        )
      })}
    </div>
  )
}
